import { useEffect } from 'react';

import { useAppActions } from '@store/useAppStore';
import { selectAppLanguage } from '@store/useAppStore';

import { useTranslationsListQuery } from '../services/useTranslationsListQuery';

const useLanguage = ({ userLanguageIsCode }) => {
  const { refetch: translationsListRefetch } = useTranslationsListQuery();

  const { setAppLanguage, setAppRtl } = useAppActions();
  const language = selectAppLanguage();

  useEffect(() => {
    if (userLanguageIsCode) {
      if (!language) {
        setAppLanguage(userLanguageIsCode);
        setAppRtl(userLanguageIsCode === 'ar');
      } else if (language !== userLanguageIsCode) {
        translationsListRefetch();
        setAppLanguage(userLanguageIsCode);
        setAppRtl(userLanguageIsCode === 'ar');
      }
    }
  }, [userLanguageIsCode]);
};

export default useLanguage;
